import Cookies from 'js-cookie';
import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    LOGOUT,
    SET_USER,
} from 'context/actions/auth';

const initialState = { loggedIn: false, user: null };

let user;
if (typeof window !== 'undefined') {
    try {
        user = JSON.parse(localStorage.getItem('user'));
    } catch (e) {
        user = null;
    }
}

if (user) {
    Object.assign(initialState, {
        loggedIn: true,
        user,
    });
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            Cookies.set('auth_token', action.data.token, { expires: 3 });
            localStorage.setItem('user', JSON.stringify(action.data));
            return {
                ...state,
                loggedIn: true,
                user: action.data,
            };
        case LOGIN_ERROR:
        case LOGOUT:
            localStorage.removeItem('user');
            Cookies.remove('auth_token');
            return { ...state, loggedIn: false, user: null };
        case SET_USER:
            localStorage.setItem('user', JSON.stringify({ ...action.data }));
            return { ...state, user: action.data };
        default:
            return state;
    }
};

export default authReducer;
